import { createReducer, createSetter } from "@/redux/helpers/reducer";
import { STATUS } from "@/utils/constants";

import * as actions from "./stripe-integration-tile.actions";

const initialState = {
  connectionStatus: null,
  fetchConnectionStatusStatus: STATUS.IDLE,
  paymentAccounts: [],
  fetchPaymentAccountsStatus: STATUS.IDLE,
  connectStripeStatus: STATUS.IDLE,
  available: false,
};

export default createReducer(initialState, {
  [actions.setConnectionStatus]: createSetter("connectionStatus"),
  [actions.setFetchConnectionStatusStatus]: createSetter("fetchConnectionStatusStatus"),
  [actions.setPaymentAccounts]: createSetter("paymentAccounts"),
  [actions.setFetchPaymentAccountsStatus]: createSetter("fetchPaymentAccountsStatus"),
  [actions.setConnectStripeStatus]: createSetter("connectStripeStatus"),
  [actions.setAvailable]: createSetter("available"),
  [actions.reset]: () => ({ ...initialState }),
});
